enum Mutations {
  SET_GENDER_DEFINITIONS = 'setGenderDefinitions',
  SET_SERVICES_DEFINITIONS = 'setServicesDefinitions',
  SET_REJECT_REASONS_DEFINITIONS = 'setRejectReasonsDefinitions',
  SET_CARE_PLANS_DEFINITIONS = 'setCarePlansDefinitions',
  SET_INSURANCE_COMPANIES_DEFINITIONS = 'setInsuranceCompaniesDefinitions',
}

export default Mutations
